import styled from 'styled-components'

export const FContainer = styled.div`
  width: 100%;
  height: 100%;
  flex-direction: column;
`

export const NContainer = styled.div`
  display: flex;
  width: 100%;
  max-width: 1325px;
  margin: 0 auto;
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  max-width: 1325px;
  margin: 0 auto;
  padding: 0 64px 64px;
  padding-top: 100px;

  @media (max-width: 768px) {
    padding: 0 24px 32px;
    gap: 16px;
  }
`

export const CardsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 16px;
  background-color: 'red';
`

export const CardItem = styled.div`
  height: 72px;
  border-radius: 8px;
  background: #fff6bb;
  border: 1px solid #9ac3a9;

  @media (max-width: 768px) {
    height: 64px;
  }
`

export const MainGrid = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 16px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`

export const LeftPanel = styled.div`
  height: 600px;
  border-radius: 10px;
  @media (max-width: 700px) {
    height: 74px;
    box-shadow: 0px 4px 13px rgba(175, 175, 175, 0.2);
  }
`

export const RightPanel = styled.div`
  height: 600px;
  border-radius: 10px;
  background: #fff;
  border: 1px solid rgba(194, 203, 217, 0.2);
  @media (max-width: 700px) {
    height: 74px;
    box-shadow: 0px 4px 13px rgba(175, 175, 175, 0.2);
  }
`

export const BottomPanel = styled.div`
  border-radius: 10px;
  padding: 10px;
  margin-top: 40px;
  border: 1px solid rgba(214, 214, 214, 0.2);
  @media (max-width: 700px) {
    height: 74px;
    box-shadow: 0px 4px 13px rgba(175, 175, 175, 0.2);
  }
`

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: 'red';
  width: 100%;
  @media (max-width: 1600px) {
    padding: 0 30px;
  }
  @media (max-width: 768px) {
    padding: 0 25px;
  }
`

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 3px solid var(--gray-50);
  height: 6vh;
  align-items: center;
  @media (max-width: 768px) {
    height: 16vh;
  }
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`

export const HeaderTitleText = styled.h1`
  color: #212d45;
  font-style: normal;
  font-weight: 700;
  font-size: 35px;
  line-height: 130%; /* 45.5px */
  text-transform: capitalize;
  @media (max-width: 768px) {
    font-size: 20px;
    font-weight: 600;
    line-height: 22px; /* 110% */
  }
`

export const CenterElement = styled.div`
  display: flex;
  align-items: center;
  .loading-spinner {
    margin-right: 20px;
  }
`

export const DetailsContainer = styled.div`
  width: 100%;
  display: flex;
  gap: 2.562rem;
  @media (max-width: 768px) {
    width: 100%;
    gap: 2.187rem;
  }
`

export const DetailsTitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`

export const TitleTextContaier = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const HeaderDetailText = styled.p`
  color: #4e6783;
  font-style: normal;
  font-size: 14px;
  font-weight: 500;
  line-height: 130%;
  @media (max-width: 768px) {
    font-size: 12px;
    font-weight: 400;
  }
`
export const HeaderDetailText2 = styled.p`
  font-style: normal;
  font-size: 18px;
  font-weight: 500;
  line-height: 130%;
  @media (max-width: 768px) {
    font-size: 16px;
    font-weight: 400;
  }
`

export const Img = styled.img`
  display: block;
  width: 20px;
  height: 20px;
`

export const CalendarContiner = styled.div`
  display: flex;
`

export const DataContainer = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  padding: 10px;
`

export const LocalContainer = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`

export const EventButtonContainer = styled.div``

export const EventButton = styled.button``

export const ImgDoughnut = styled.img`
  display: inline-block;
  height: 20px;
  width: 25px;
`

export const ChartContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`

export const DateManager = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 39px;
  @media (max-width: 530px) {
    margin-top: 36px;
  }
`

export const SelectDateContainerMobile = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 30px;
  width: 100%;
  max-width: 265px;
  position: relative;
  font-weight: 500;
  display: none;
  &:before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: inherit;
    height: 3px;
    background-color: var(--gray-50);
  }
  @media (max-width: 770px) {
    display: flex;
    gap: 20px;
    justify-content: start;
  }
  @media (max-width: 420px) {
    font-size: 12px;
    max-width: 237px;
  }
`

export const SelectDateContainer = styled.div`
  display: flex;
  gap: 30px;
  flex: 1;
  font-weight: 500;
  position: relative;
  justify-content: space-between;
  &:before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background-color: var(--gray-50);
  }

  @media (max-width: 770px) {
    display: none;
  }
`

export const SelectDateTextMobile = styled.div`
  align-items: center;
  display: flex;
  height: 50px;
  cursor: pointer;
  position: relative;
  color: #72899d;
  &.active {
    color: #000;
    font-weight: 600;
  }
  &:hover {
    color: #000;
    font-weight: 600;
  }
  &:hover::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background-color: red;
  }
  &.active::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background-color: red;
  }
`

export const SelectDateText = styled.div`
  align-items: center;
  display: flex;
  height: 50px;
  cursor: pointer;
  position: relative;
  white-space: nowrap;
  color: #72899d;
  &.active {
    color: #000;
    font-weight: 600;
  }
  &:hover {
    color: #000;
    font-weight: 600;
  }
  &:hover::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background-color: red;
  }
  &.active::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background-color: red;
  }
`

export const TotalCardContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 24px;
  margin-top: 39px;
  @media (max-width: 1000px) {
    display: grid;
    grid-template-rows: 1fr 1fr;
    grid-template-columns: 1fr 1fr;
  }
  @media (max-width: 420px) {
    gap: 8px;
    margin-top: 24px;
  }
`

export const SalesCardContainer = styled.div`
  display: flex;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export const DashboardDoughnutChart = styled.div`
  margin-right: 20px;
`

export const DoughnutDetailsIconContainer = styled.div`
  display: flex;
  align-items: center;

  &:after {
    content: '';
    width: 3px;
    height: 39px;
    background-color: #000000;
    border-radius: 1px;
    margin-right: 19px;
    margin-left: 19px;
    display: inline-block;
  }
`

export const DoughnutDetailsContainer = styled.div`
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  gap: 30px;
`

export const DoughnutDetailsRollContainer = styled.div`
  display: flex;
  align-items: center;
`

export const DoughnutDataContainer = styled.div``

export const DoughtDataText = styled.p`
  font-size: 12px;
  font-weight: 500;
`

export const DoughtDataNumber = styled.p`
  font-size: 22px;
  font-weight: 700;
`

export const PageVisitsCardContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 24px;
  @media (max-width: 1406px) {
    flex-wrap: wrap;
  }
  @media (max-width: 806px) {
    gap: 1.5rem;
  }
`

export const ManagerGoalsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`

export const GoalsManagerCardContainer = styled.div`
  display: block;
`

export const SalesByProductContainer = styled.div`
  display: block;
  margin-top: 24px;
  @media (max-width: 806px) {
    margin-top: 1.5rem;
  }
`

export const VisitorsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 24px;
  margin-top: 24px;
  @media (max-width: 1340px) {
    flex-wrap: wrap;
  }
  @media (max-width: 840px) {
    gap: 1.5rem;
  }
  @media (max-width: 806px) {
    margin-top: 1.5rem;
  }
`

export const HeatMapContainer = styled.div`
  display: flex;
  flex-direction: column;
`
export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 32px;
  @media (max-width: 768px) {
    margin-top: 24px;
  }
`
